/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AssegnazioneArticoloCedolaAttivoPatchForm } from '../model/models';
import { AssegnazioneArticoloCedolaCreationForm } from '../model/models';
import { AssegnazioneArticoloCedolaDTO } from '../model/models';
import { AssegnazioneArticoloCedolaListFilter } from '../model/models';
import { AssegnazioneArticoloCedolaPatchForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelAssegnazioneArticoloCedolaDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateAssegnazioneArticoloCedolaRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
    assegnazioneArticoloCedolaCreationForm: AssegnazioneArticoloCedolaCreationForm;
}

export interface DeleteAssegnazioneArticoloCedolaRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
    idArticolo: string;
}

export interface GetAssegnazioneArticoloCedolaRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
    idArticolo: string;
}

export interface ListAssegnazioneArticoliCedolaRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
    filter: AssegnazioneArticoloCedolaListFilter;
    pageable: Pageable;
}

export interface SetAttivoAssegnazioneArticoloCedolaRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
    idArticolo: string;
    assegnazioneArticoloCedolaAttivoPatchForm: AssegnazioneArticoloCedolaAttivoPatchForm;
}

export interface UpdateAssegnazioneArticoloCedolaRequestParams {
    idTipoPratica: string;
    idIstituto: string;
    idPlesso: string;
    idAssegnazione: string;
    idArticolo: string;
    assegnazioneArticoloCedolaPatchForm: AssegnazioneArticoloCedolaPatchForm;
}


export interface AssegnazioneArticoloCedolaControllerServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un nuovo articolo cedola sotto l\&#39;Assegnazione (rifiutato se Assegnazione.contributo IS NOT NULL — vincolo XOR)
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole
* @param requestParameters
     */
    createAssegnazioneArticoloCedola(requestParameters: CreateAssegnazioneArticoloCedolaRequestParams, extraHttpRequestParams?: any): Observable<AssegnazioneArticoloCedolaDTO>;

    /**
     * Soft-delete di un articolo cedola (flip attivo&#x3D;false). La riga resta in DB; per eliminarla fisicamente, DELETE sull\&#39;Assegnazione parent (cascade hard).
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole/{idArticolo}
* @param requestParameters
     */
    deleteAssegnazioneArticoloCedola(requestParameters: DeleteAssegnazioneArticoloCedolaRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un articolo cedola per id
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole/{idArticolo}
* @param requestParameters
     */
    getAssegnazioneArticoloCedola(requestParameters: GetAssegnazioneArticoloCedolaRequestParams, extraHttpRequestParams?: any): Observable<AssegnazioneArticoloCedolaDTO>;

    /**
     * Lista paginata degli articoli cedola di un\&#39;Assegnazione (filtri: area containsCi, editore eq, attivo bool default&#x3D;true, q containsCi titolo+editore+note). Default sort: area ASC, titolo ASC. Default strict su attivo: senza ?attivo&#x3D; ritorna solo attivo&#x3D;true
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole
* @param requestParameters
     */
    listAssegnazioneArticoliCedola(requestParameters: ListAssegnazioneArticoliCedolaRequestParams, extraHttpRequestParams?: any): Observable<PagedModelAssegnazioneArticoloCedolaDTO>;

    /**
     * Toggle attivo di un articolo cedola (riattivazione o disattivazione esplicita). Riattivazione (attivo&#x3D;true) rifiutata se Assegnazione.contributo IS NOT NULL (XOR).
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole/{idArticolo}/attivo
* @param requestParameters
     */
    setAttivoAssegnazioneArticoloCedola(requestParameters: SetAttivoAssegnazioneArticoloCedolaRequestParams, extraHttpRequestParams?: any): Observable<AssegnazioneArticoloCedolaDTO>;

    /**
     * Replace di un articolo cedola (richiede version per optimistic lock). Operativo solo su articoli attivi&#x3D;true: per riattivare un articolo soft-deleted usare PATCH /attivo. Rifiutato se Assegnazione.contributo IS NOT NULL (XOR).
     * 
     * @endpoint put /api/v1/gestione/tipi-pratica/{idTipoPratica}/istituti/{idIstituto}/plessi/{idPlesso}/assegnazioni/{idAssegnazione}/articoli-cedole/{idArticolo}
* @param requestParameters
     */
    updateAssegnazioneArticoloCedola(requestParameters: UpdateAssegnazioneArticoloCedolaRequestParams, extraHttpRequestParams?: any): Observable<AssegnazioneArticoloCedolaDTO>;

}
